module.exports = __webpack_public_path__ + "images/8065b9a45102e8fe6fc95b94014f5b7f.png";